export function _getDUID() {
  if (!window.tizen) return 'Web'
  const { duid }: { duid: string } = window.tizen.systeminfo.getCapabilities()
  return duid
}

function _getDevice() {
  if (!window.tizen) {
    return 'Web'
  }

  const productinfo = webapis.productinfo
  const modelCode = productinfo.getModel()

  return modelCode ?? 'desktop'
}

function _getIsMute() {
  if (!window.tizen) {
    return false
  }
  return !!window.tizen.tvaudiocontrol.isMute()
}

function _getUA() {
  const _ua = navigator.userAgent
  if (!window.tizen) {
    return _ua
  }

  const regex = /[)]/
  const modelCode = webapis.productinfo.getModelCode() ?? ''
  return _ua.replace(regex, ` ${modelCode})`)
}

function _initKinesis() {
  const dt = new Date().toISOString()
  const _os = 'tizen'
  const duid = _getDUID()
  const ageCode = 'etc' as IKinesisRecord['ageCode']
  const genderCode = 'e' as IKinesisRecord['genderCode']
  const isAdmin = false
  const isTest = window.tizen ? false : true
  const isMute = _getIsMute()
  const usedSource = 'SF-W-T'
  const userAgent = _getUA()
  const playStart = new Date().toISOString()
  const timeSinceStart = 0
  const memberTypeCode = '0' as IKinesisRecord['memberTypeCode']
  const memberId = _getDUID()
  const modelTypeCode = _getDevice()

  return {
    dt,
    os: _os,
    duid,
    ageCode,
    genderCode,
    isAdmin,
    isTest,
    isMute,
    usedSource,
    userAgent,
    playStart,
    timeSinceStart,
    memberTypeCode,
    memberId,
    modelTypeCode,
  }
}

function getKinesis() {
  return _kinesis
}

function updatePlayStart(playStart: string) {
  _kinesis.playStart = playStart
}

const _kinesis = _initKinesis()

export { getKinesis, updatePlayStart }
